import { useEffect } from "react";
import Router from "./router";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useToast } from "@chakra-ui/react";
import { useState } from "react";
import Seo, { schema } from "./utilities/Seo";
import { Helmet } from "react-helmet-async";
import {
  clearAuthSession,
  getAuthToken,
  hydrateAuthTokenToSession,
} from "./utilities/sessionAuth";

function App() {
  const [show , setShow] = useState(false);
  const [authToken, setAuthToken] = useState(() => getAuthToken());
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const publicPaths = ["/login", "/forgot-password", "/register", "/verification-pending" ,"/resetPassword"];

  useEffect(() => {
    const checkTokenValidity = () => {
      const token = hydrateAuthTokenToSession();
      if (!token) {
        setAuthToken(null);
        if (!publicPaths.includes(location.pathname)) {
          setShow(true);
          navigate("/login");
        } else {
          setShow(true);
        }
        return;
      } else {
        try {
          const decodedToken = jwtDecode(token.split(" ")[1]);
          const expirationTime = decodedToken.exp * 1000;
          const currentTime = Date.now();
          
          if (expirationTime < currentTime) {
            setShow(false);
            toast({
              title: "Session has expired, please login again",
              status: "warning",
              duration: 4000,
              position: "top",
              isClosable: true,
            });
            clearAuthSession();
            setAuthToken(null);
            navigate("/verification-pending");
            return;
          }
          
          // Check if academy is authorized
          if (decodedToken?.academyId?.authStatus !== "authorized") {
            setShow(false);
            // If user is trying to access protected routes, redirect to verification-pending
            if (!publicPaths.includes(location.pathname)) {
              navigate("/verification-pending");
              return;
            }
          }
          setAuthToken(token);
          setShow(true);
        } catch (error) {
          console.error("Error decoding token:", error);
          clearAuthSession();
          setAuthToken(null);
          navigate("/login");
          setShow(true);
        }
      }
    };

    checkTokenValidity();
  }, [navigate, location.pathname, toast]);

  return (
    <>
      <Helmet>
        <meta name="x-helmet-test" content="present" />
      </Helmet>
      <Seo
        title="KhelSport Academy Dashboard"
        description="Manage academy, courses, coaches, players and reports."
        canonical={typeof window !== "undefined" ? window.location.href : undefined}
        url={typeof window !== "undefined" ? window.location.href : undefined}
        image={"https://khelcoach.com/public/images/preview/a.jpg"}
        jsonLd={schema.localBusiness({
          name: "KhelSport Academy",
          url: "https://khelcoach.com",
          image: "https://khelcoach.com/public/images/preview/a.jpg",
        })}
      />
      {show && <Router auth={authToken} />}
    </>
  );
}

export default App;
